import {Box, Button} from "@mui/material";
import * as React from "react";
import {useCallback, useState} from "react";
import {CloneEventUsingPOSTPartsEnum, CloneReport} from "../../generated-api";
import {useAppDispatch} from "../../store";
import {cloneEvent} from "../../store/events";
import {getApiResult} from "../../helpers/api";
import {useAppTranslation} from "../../services/i18n";
import {addMessage} from "../../store/localApp";
import EventCloneModal from "../../pages/EventCloneModal";

type CloneReports = { [key in string]?: CloneReport };

/** Placeholder of an empty event codebook, offers to copy it from another event. */
const EventCloneEmpty = (props: {
    eventId: number,
    parts: CloneEventUsingPOSTPartsEnum[],
    text: string,
    title: string,
    info: string,
    onCloned: () => void,
}) => {
    const {eventId, parts, text, title, info, onCloned} = props;

    const t = useAppTranslation();
    const dispatch = useAppDispatch();
    const [isOpen, setIsOpen] = useState(false);

    const handleClone = useCallback(async (sourceEventId: number) => {
        const res = await dispatch(cloneEvent({eventId, sourceEventId, parts}));
        const reports = getApiResult<CloneReports>(res);
        if (reports) {
            const created = Object.values(reports).reduce((sum, r) => sum + (r?.created || 0) + (r?.updated || 0), 0);
            dispatch(addMessage({
                code: 'OK',
                action: 'event/clone',
                severity: created ? 'success' : 'info',
                title: created ? t('Zkopírováno záznamů: {{n}}', {n: created}) : t('Ve zdrojové události nebylo co kopírovat'),
            }));
            setIsOpen(false);
            onCloned();
        }
    }, [eventId, parts, dispatch, onCloned, t]);

    return <Box sx={{padding: '16px', textAlign: 'center'}}>
        <p>{text}</p>
        <Button variant={'contained'} size={'small'} color={'primary'} sx={{marginTop: 1}}
            onClick={() => setIsOpen(true)}>{t('Zkopírovat z jiné události')}</Button>
        {isOpen && <EventCloneModal
            eventId={eventId}
            title={title}
            info={info}
            onCancel={() => setIsOpen(false)}
            onSave={handleClone}
        />}
    </Box>;
}

export default EventCloneEmpty;
